import styled from 'styled-components';

export const SC_TooltipImagem = styled.div`
    p {
        font-size: 12px !important;
        margin: 0 0 !important;
        line-height: 18px;
        color: var(--dim-gray);
    }
`